import KaraokeAnimationModule from './KaraokeAnimationModule';

export default KaraokeAnimationModule;
